import { useTranslation } from 'react-i18next';
import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ButtonsWrapper,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import PermissionCheck from 'src/components/permission-check';

import { TopbarWrapper } from './page-topbar.styles';
import { TitleRowLabel } from '../employee-common.styles';

const PageTopbar = ({
  pageTitle,
  onClickEdit,
  createButton,
  createdBy,
  needPermissionToEdit,
  softTitle,
}: {
  pageTitle: string;
  onClickEdit: () => void;
  createButton?: {
    title: 'title';
    onClickCreate: () => void;
  };
  createdBy?: string;
  needPermissionToEdit?: boolean;
  softTitle?: boolean;
}) => {
  const { t } = useTranslation(['common']);

  return (
    <TopbarWrapper>
      {softTitle ? (
        <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {pageTitle}
        </TitleRowLabel>
      ) : (
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {pageTitle}
        </Typography>
      )}
      <ButtonsWrapper>
        {createButton && (
          <PermissionCheck
            permission={PLATFORM_PERMISSIONS.memberManagement}
            action={PERMISSION_ACTIONS.update}
            createdBy={createdBy}
          >
            <Button
              type="primary"
              ghost
              icon={ICONS.plus}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={createButton.onClickCreate}
            >
              {createButton.title}
            </Button>
          </PermissionCheck>
        )}
        {needPermissionToEdit ? (
          <PermissionCheck
            permission={PLATFORM_PERMISSIONS.memberManagement}
            action={PERMISSION_ACTIONS.update}
            createdBy={createdBy}
          >
            <Button
              type="primary"
              ghost
              icon={ICONS.editAlt}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={onClickEdit}
            >
              {t('common:buttons.edit')}
            </Button>
          </PermissionCheck>
        ) : (
          <Button
            type="primary"
            ghost
            icon={ICONS.editAlt}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
            onClick={onClickEdit}
          >
            {t('common:buttons.edit')}
          </Button>
        )}
      </ButtonsWrapper>
    </TopbarWrapper>
  );
};

export default PageTopbar;
